import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';

import { apolloClient } from './graphql/ApolloClient';

import { ApolloProvider } from '@apollo/client';
import 'remixicon/fonts/remixicon.css';

import { configureNewRelic } from './newrelic/newrelic';
import { runEpics, store } from './redux/store';

runEpics();
// //activating new relic metrics
if (import.meta.env.VITE_NR_ACTIVATE_METRICS === 'true') {
	const configNewRelicByEnvironment = document.createElement('script');
	configNewRelicByEnvironment.text = configureNewRelic();
	configNewRelicByEnvironment.async = true;
	document.head.insertBefore(configNewRelicByEnvironment, document.head.firstElementChild);

	const configNewRelic = document.createElement('script');
	configNewRelic.src = '/scripts/newrelic.js';
	configNewRelic.async = true;
	document.head.insertBefore(configNewRelic, document.head.firstElementChild);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<Provider store={store}>
		<ApolloProvider client={apolloClient}>
			<App />
		</ApolloProvider>
	</Provider>
);
